import React from 'react';
import { Tag } from 'antd';
export var AccessChangeType;
(function (AccessChangeType) {
    AccessChangeType[AccessChangeType["NewAccess"] = 1] = "NewAccess";
    AccessChangeType[AccessChangeType["NewUser"] = 3] = "NewUser";
    AccessChangeType[AccessChangeType["NewApp"] = 4] = "NewApp";
})(AccessChangeType || (AccessChangeType = {}));
const accessChangeText = {
    [AccessChangeType.NewAccess]: 'New Access',
    [AccessChangeType.NewUser]: 'New User',
    [AccessChangeType.NewApp]: 'New App'
};
const accessChangeColor = {
    [AccessChangeType.NewAccess]: 'orange',
    [AccessChangeType.NewUser]: 'cyan',
    [AccessChangeType.NewApp]: 'purple'
};
export const AccessChangeTypeTag = ({ changeType }) => React.createElement(Tag, { color: accessChangeColor[changeType] }, accessChangeText[changeType]);
